// Copyright (c) 2022 by Move Closer

import { AnyObject } from '@movecloser/front-core'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface HeadingData {
  /**
   * Determines font color of the text.
   */
  color: string

  /**
   * Determines content of the heading.
   */
  content: string

  /**
   * Determines the <h> tag level
   */
  level: number

  /**
   * Determines the size of the heading.
   */
  size: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface HeadingDataProps {
  /**
   * Object in which heading data will be stored.
   */
  _content: AnyObject
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type HeadingFormData = HeadingData

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum HeadingTextColor {
  Dark = 'dark',
  Light = 'light'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const headingTextColors: Record<string, string> = {
  [HeadingTextColor.Dark]: '--dark',
  [HeadingTextColor.Light]: '--light'
}
